import Span from "@ui/elements/Span"
import Div from "@ui/layout/Div"
import { useTranslation } from "react-i18next"

const useTreatmentCSSClass = () => {
  const [t] = useTranslation('sterilization')
  const getTreatmentCSSClass = (treatmentJournals, nbScanPhotos = 0) => {
    if (0 === treatmentJournals.length) return 'non-scanned'

    const isFirstScanned = treatmentJournals['firstScan'] ? treatmentJournals['firstScan']['isDone'] : false
    const isSecondScanned = treatmentJournals['secondScan'] ? treatmentJournals['secondScan']['isDone'] : false

    if (!isFirstScanned && !isSecondScanned && nbScanPhotos > 0) return 'is-visited'

    return isFirstScanned && isSecondScanned
      ? 'is-full-scanned'
      : (isSecondScanned
        ? 'is-second-scanned'
        : (isFirstScanned
          ? 'is-first-scanned'
          : 'non-scanned'
        ))
  }

  const generateTreatmentCSSClass = () => {
    const classes = {
      'is-first-scanned': t('labels.is_first_scanned'),
      'is-second-scanned': t('labels.is_second_scanned'),
      'is-full-scanned': t('labels.is_full_scanned'),
      'is-visited': t('labels.is_visited'),
      'non-scanned': t('labels.non_scanned')
    }

    return <Div cssClass='treatment-css-colors'>
      <h3>{t('labels.treatment_colors')}</h3>
      {Object.keys(classes).map(cssClass => <Span key={cssClass} cssClass={`treatment-color ${cssClass}`}>{classes[cssClass]}</Span>)}
    </Div>

  }

  return [getTreatmentCSSClass, generateTreatmentCSSClass]
}

export default useTreatmentCSSClass